import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import FormSelect from '../../../../../../antd/form/FormSelect/FormSelect';
import { required } from '../../../../../../antd/form/FormValidation';
import FormButton from '../../../../../../antd/form/FormButton/FormButton';
import FormButtonsContainer from '../../../../../../antd/form/FormButtonsContainer/FormButtonsContainer';
import Form from '../../../../../../antd/form/Form/Form';
import { CollapseBlock, Spinner } from '../../../../../../common/index';
import FormTextField from '../../../../../../antd/form/FormTextField/FormTextField';
import { useDataGridTextFilter } from '../../../../../../common/DataGrid/filters/useDataGridTextFilter';
import DataGrid from '../../../../../../common/DataGrid/DataGrid';
import { dataGridTextSorter } from '../../../../../../common/DataGrid/sorters/DataGridSorters';

const ErasmusConsortiumForm = ({
  onSubmit,
  initials,
  isEdit,
  isPreview,
  universities,
  onConsortiumUniDelete,
  filteredUniversities,
}) => {
  const { t } = useTranslation();

  const filteredUniversitiesOptions = useMemo(
    () =>
      universities.map((item) => {
        return {
          value: item.id,
          label: item.name,
        };
      }),
    [universities],
  );

  const nameOfPermissionFilterProps = useDataGridTextFilter('name');

  const columnsUniversities = useMemo(
    () => [
      {
        title: t('Názov univerzity'),
        dataIndex: 'name',
        ellipsis: true,
        sorter: dataGridTextSorter('name'),
        ...nameOfPermissionFilterProps,
      },
    ],
    [t, nameOfPermissionFilterProps],
  );

  if (!initials && isLoading) {
    return <Spinner />;
  }
  return (
    <Form onFinish={onSubmit} initialValues={initials}>
      <CollapseBlock title={t('Údaje konzorcia')}>
        <FormTextField
          label={t('Názov')}
          name={'name'}
          rules={[required(t)]}
          disabled={isPreview}
        />
        <FormSelect
          label={t('Univerzity')}
          name={'choosedUniversitiesIds'}
          placeholder={t('Vyhľadať univerzitu')}
          options={filteredUniversitiesOptions}
          mode={'multiple'}
          disabled={isPreview}
        />
        {(isEdit || isPreview) && (
          <DataGrid
            rowKey={(data) => data.id}
            columns={columnsUniversities}
            dataSource={filteredUniversities || []}
            permissionsBasic={'erasmus-consortiums'}
            onDelete={isPreview ? undefined : onConsortiumUniDelete}
            openDeleteModal={false}
            disableSettings={isPreview}
          />
        )}
      </CollapseBlock>
      {isPreview ? null : (
        <FormButtonsContainer>
          <FormButton submitOnClick={true} submitKey={'erasmusApplications'}>
            {t('Uložiť')}
          </FormButton>
        </FormButtonsContainer>
      )}
    </Form>
  );
};

export default ErasmusConsortiumForm;
